import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import API_URL from '../config';

// Générer ou récupérer un identifiant unique pour cet appareil
const getDeviceFingerprint = () => {
  let fingerprint = localStorage.getItem('device_fingerprint');
  if (!fingerprint) {
    // Générer un UUID unique v4
    fingerprint = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
    localStorage.setItem('device_fingerprint', fingerprint);
  }
  return fingerprint;
};

function RedirectPage() {
  const { uniqueLink } = useParams();
  const hasRedirected = useRef(false);

  useEffect(() => {
    // Éviter les doubles appels en mode développement (React StrictMode)
    if (hasRedirected.current) return;
    hasRedirected.current = true;

    const redirect = async () => {
      try {
        const deviceFingerprint = getDeviceFingerprint();
        
        const response = await fetch(`${API_URL}/api/link/${uniqueLink}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            device_fingerprint: deviceFingerprint
          })
        });
        
        if (response.ok) {
          const data = await response.json();
          // Redirection instantanée vers l'URL Google Avis
          window.location.href = data.redirect_url;
        } else {
          // Si le lien n'existe pas, rediriger vers la page d'accueil
          window.location.href = '/app';
        }
      } catch (error) {
        console.error('Erreur lors de la redirection:', error);
        window.location.href = '/app';
      }
    };

    redirect();
  }, [uniqueLink]);

  // Page blanche pendant la redirection
  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      backgroundColor: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        fontSize: '1.125rem',
        color: '#666',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}>
        Redirection en cours...
      </div>
    </div>
  );
}

export default RedirectPage;
